import React, { Fragment } from 'react'

import { Transition } from '@headlessui/react'
import { ExclamationIcon } from '@heroicons/react/solid'
import { useGlobalState } from '@/state'

// Just the toast now. The counts and the version check both arrive on the
// NotificationsChannel socket PopupAlert already opens:
//
//   releaseInfo     - the deploy that served this tab, set by Header from props
//   liveReleaseInfo - the deploy that's running, sent by the channel on every
//                     subscribe, and a deploy is exactly what drops the socket
//                     and forces a resubscribe
//
// So they differ only when the deploy really did move under this tab, and we
// find out on reconnect instead of up to five minutes later.
export default function SiteNotification() {
  const [releaseInfo] = useGlobalState('releaseInfo')
  const [liveReleaseInfo] = useGlobalState('liveReleaseInfo')
  const show = Boolean(releaseInfo && liveReleaseInfo && releaseInfo !== liveReleaseInfo)

  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div aria-live="assertive" className="fixed inset-0 z-30 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-sm w-full bg-white dark:bg-gray-800 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5" >
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <ExclamationIcon className="h-6 w-6 text-yellow-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium dark:text-yellow-600 text-yellow-500">Out of Date Version</p>
                    <p className="mt-1 text-sm dark:text-gray-100 text-gray-500">
                    You are using an old version of Casting Call Club and if you run an older version, you might experience bugs. <a className="text-cccblue cursor-pointer" onClick={() => { window.location.reload() }}>Click here to reload the page and get the latest version.</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  )
}
